<div>
    <div class="row ">
        <div class="col pl-3">
            <h4 class="mb-0 font-header" style="font-weight: 700;">Schedule</h4>
        </div>
    </div>
    <div
        *ngIf="global.globalAgencyId == '' || global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
        <div class="row mt-4 ">
            <div class="col ">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body  widget-body pt-2">
                        <div class="text-center text-danger">
                            <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                agency to view
                                details</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-4"
        *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
        <div class="col">
            <div widget class="card border-0 box-shadow p-3" style="min-height: 700px;">
                <div class="row">
                    <div class="col-lg-3">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">From<sup class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [selDate]="ListStartDate" placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="Schedulenewdates($event,'inputchanged','ListStart')"
                                (dateChanged)="Schedulenewdates($event,'datechanged','ListStart')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">To<sup class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [selDate]="ListEndDate" placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="Schedulenewdates($event,'inputchanged','ListEnd')"
                                (dateChanged)="Schedulenewdates($event,'datechanged','ListEnd')">
                            </my-date-picker>
                        </div>
                    </div>

                </div>
                <div class="row mt-2">
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Employee </label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [(ngModel)]="ListEmployeeId" [searchable]="true" [clearable]="true"
                                bindLabel="Value" bindValue="Key" [items]="EmployeeDropdown">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Client </label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [(ngModel)]="ListClientId" [searchable]="true" [clearable]="true"
                                [items]="ClientDropdown" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="float-end mt-2">
                        <button class="btn blue-btn mb-1" (click)="EmitToEditpage()" *ngIf="fp.ScheduleCreate">Add
                            Schedule</button>
                        <button type="button" class="btn blue-btn ms-2 mb-1 " [disabled]="ListStartDate==null ||
                      ListStartDate==undefined || ListStartDate=='' ||
                      ListEndDate==null ||ListEndDate==undefined || ListEndDate=='' " (click)="ApplyFilter()">Apply
                        </button>
                        <button type="button" class="btn blue-btn ms-2 mb-1" (click)="Refresh()"><i
                                class="fa fa-repeat"></i>&nbsp;Refresh
                        </button>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-lg-12">
                        <div class="control-section">
                            <ejs-grid #gridSchedule [dataSource]='GridDataList | async' [allowResizing]='true'
                                [allowSorting]='true' allowPaging='true' [allowFiltering]='true'
                                [pageSettings]='initialPage' [filterSettings]='filterSettings'
                                [childGrid]='childEjsScheduleGrid' (actionBegin)="onActionComplete($event)"
                                (resizeStop)="onResize($event)" (dataStateChange)='dataStateChange($event)'
                                [showColumnChooser]='true'>
                                <e-columns>
                                    <!-- Action -->
                                    <e-column headerText="Actions" uid="action" textAlign="center"
                                        [allowFiltering]="false" [allowSorting]='false' [showInColumnChooser]='false'
                                        minWidth="70">
                                        <ng-template #template let-data>
                                            <button class="btn btn-edit-table Ationsubbtn" *ngIf="fp.ScheduleUpdate"
                                                (click)="editSchedule(data,'parentgrid')" data-bs-toggle="modal"
                                                data-bs-target="#UpdateScheduleAppointmentModal"><i
                                                    class="fa fa-edit"></i></button>

                                            <button class=" btn btn-delete-table ms-2" *ngIf="fp.ScheduleDelete"
                                                data-bs-target="#DeleteParentGrid" data-bs-toggle="modal"
                                                (click)="visitscheduleId=data.id;DeleteType='DeleteEnterSeries'">
                                                <i class="fa fa-trash fa-lg"></i></button>
                                        </ng-template>
                                    </e-column>
                                    <!-- Client -->
                                    <e-column field="clientName" headerText="Client" minWidth="140" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- Employee -->
                                    <e-column field="employeeName" headerText="Employee" minWidth="140" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- ServiceGroup-->
                                    <e-column field="serviceGroupName" headerText="Service Group" minWidth="150"
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- Service -->
                                    <e-column field="serviceName" headerText="Service" minWidth="150" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- Start Date -->
                                    <e-column field="startDate" headerText="Start Date" minWidth="100"
                                        textAlign='center' [allowEditing]='false' type='datetime'
                                        [format]='formatOptions' [allowFiltering]="false" [allowSorting]='false'>
                                    </e-column>
                                    <!-- End Date -->
                                    <e-column field='endDate' headerText='End Date' minWidth="100"
                                        [allowSorting]='false' [allowFiltering]="false" textAlign='left'
                                        [allowEditing]='false' type='datetime' [format]='formatOptions'>
                                    </e-column>

                                    <!-- Start Time -->
                                    <e-column field="setstartTime" headerText="Start Time" minWidth="100"
                                        textAlign='center' [allowEditing]='false' type='string' [allowFiltering]="false"
                                        [allowSorting]='false'>
                                    </e-column>
                                    <!-- End Time -->
                                    <e-column field='setendTime' headerText='End Time' minWidth="100"
                                        [allowSorting]='false' [allowFiltering]="false" textAlign='left'
                                        [allowEditing]='false' type='string'>
                                    </e-column>
                                    <!-- Frequency Days -->

                                    <e-column field="frequencyDays" headerText="Frequency Type" minWidth="100"
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- Days -->
                                    <e-column field="scheduleWeekDays" headerText="Days" minWidth="100" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- Total hours -->
                                    <e-column field='totalhours' headerText='Total hours' minWidth="100"
                                        [allowFiltering]="false" [allowSorting]='false' textAlign='left'
                                        [allowEditing]='false' type='number'>
                                    </e-column>
                                    <e-column width="50" [showInColumnChooser]='false'>
                                        <ng-template #headerTemplate let-data>
                                            <div>
                                                <span id='show' (click)='showorHideColumns()'><i class="fa fa-cog fa-lg"
                                                        aria-hidden="true"> </i></span>
                                            </div>
                                        </ng-template>
                                    </e-column>
                                </e-columns>

                            </ejs-grid>
                            <div *ngIf="ScheduleList.length==0" class="text-center" style="color:red">
                                <p>No data available</p>
                            </div>
                        </div>
                        <ng-template #childtemplate let-data>
                            <div><button class="btn btn-edit-table Ationsubbtn" (click)="editSchedule(data,'childgrid')"
                                    data-bs-toggle="modal" data-bs-target="#UpdateScheduleAppointmentModal"
                                    *ngIf="fp.ScheduleUpdate" [disabled]="data.isViststarted=='Started'"><i
                                        class="fa fa-edit"></i></button>
                                <button class="btn btn-delete-table ms-2" (click)="AppointmentId=data.appointmentId"
                                    [disabled]="data.isViststarted=='Started'" data-bs-toggle="modal"
                                    data-bs-target="#DeleteChildGrid" *ngIf="fp.ScheduleDelete">
                                    <i class="fa fa-trash fa-lg"></i></button>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- DeleteParentGrid -->
<span id="openParentDeleteModal" data-bs-toggle="modal" data-bs-target="#DeleteParentGrid"></span>
<div class="modal fade" id="DeleteParentGrid" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog create-update-sa" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="font-header modal-title ">
                    Delete</h5>
                <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal"
                    (click)="DeleteType=null;DeleteStartDate='';DeleteEndDate=''">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- <div class="row">
                    <div class="col-lg-12">
                        <label>Are you sure you want to delete all the unused appointments?</label>
                    </div>
                </div> -->
                <div class="row ms-0">
                    <div class="col-lg-5">
                        <input type="radio" class="mt-1" name="ES" value="DeleteEnterSeries"
                            [(ngModel)]="DeleteType">&nbsp;
                        <label for="Es">Entire series</label>

                    </div>
                    <div class="col-lg-7">
                        <input type="radio" class="mt-1" name="SDR" value="DeleteSelecteDateRange"
                            [(ngModel)]="DeleteType">&nbsp;
                        <label for="SDR">Selected Date
                            Range</label>
                    </div>
                </div>
                <div class="row mt-2" *ngIf="DeleteType=='DeleteSelecteDateRange'">
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">From<sup class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [selDate]="DeleteStartDate" placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="Schedulenewdates($event,'inputchanged','ScheduleDeleteStart')"
                                (dateChanged)="Schedulenewdates($event,'datechanged','ScheduleDeleteStart')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">To<sup class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [selDate]="DeleteEndDate" placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="Schedulenewdates($event,'inputchanged','ScheduleDeleteEnd')"
                                (dateChanged)="Schedulenewdates($event,'datechanged','ScheduleDeleteEnd')">
                            </my-date-picker>
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" [hidden]="DeleteType=='DeleteSelecteDateRange'" [disabled]="IsButtonDisable" class="btn blue-btn"
                    (click)="DeleteVisitSchedule()">
                    Ok</button>
                <button type="button" [hidden]="DeleteType=='DeleteEnterSeries'" class="btn blue-btn"
                    (click)="DeleteSelectedDateAppointments()" [disabled]="IsButtonDisable || DeleteEndDate==null || DeleteEndDate==undefined ||
                DeleteEndDate=='' ||DeleteStartDate==null || DeleteStartDate==undefined || DeleteStartDate==''">
                    Ok</button>

                <button type="button" class="btn blue-btn" data-bs-dismiss="modal"
                    (click)="DeleteType=null;DeleteStartDate='';DeleteEndDate=''">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- DeleteChildGrid -->
<span id="openChildDeleteModal" data-bs-toggle="modal" data-bs-target="#DeleteChildGrid"></span>
<div class="modal fade" id="DeleteChildGrid" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog create-update-sa" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="font-header modal-title ">
                    Delete</h5>
                <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this appointment?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" [disabled]="IsButtonDisable" (click)="DeleteAppointment()">
                    Ok</button>
                <button type="button" class="btn blue-btn" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- UpdateScheduleAppointmentModal -->
<span id="openUpdateScheduleAppointment" data-bs-toggle="modal" data-bs-target="#UpdateScheduleAppointmentModal"></span>
<div class="modal fade " id="UpdateScheduleAppointmentModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="row">
                    <div class="col-lg-5">
                        <h5 class="modal-title font-header" id="exampleModalLabel">UpdateScheduleAppointment</h5>
                    </div>
                    <div class="col-lg-7 text-center">
                        <div class="row ms-0">
                            <div class="col-lg-5">
                                <input type="radio" *ngIf="checkScheduleType=='parentgrid'" class="mt-1" name="ES"
                                    value="enterseries" [(ngModel)]="scheduleRadioType"
                                    (ngModelChange)="selectRadioType()">&nbsp;
                                <label for="Es" *ngIf="checkScheduleType=='parentgrid'">Entire series</label>

                            </div>
                            <div class="col-lg-7">
                                <input type="radio" *ngIf="checkScheduleType=='parentgrid'" class="mt-1" name="SDR"
                                    value="selectdaterange" [(ngModel)]="scheduleRadioType"
                                    (ngModelChange)="selectRadioType()">&nbsp;
                                <label for="SDR" *ngIf="checkScheduleType=='parentgrid'">Selected Date
                                    Range</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" text-right">
                    <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
                </div>
            </div>
            <div class="modal-body">
                <div class="row">
                    <!-- Client Name -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Client Name <sup *ngIf="checkScheduleType=='parentgrid'"
                                    class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12">
                            <input [(ngModel)]="clientName" *ngIf="checkScheduleType=='childgrid'" class="form-control"
                                disabled>
                            <ng-select *ngIf="checkScheduleType=='parentgrid'"
                                [(ngModel)]="updateAppointmentUpdateBO.clientId" [searchable]="true" [clearable]="true"
                                bindLabel="Value" bindValue="Key" [items]="ClientDropdown"
                                (ngModelChange)="getEmployeeRelationsip('clear');getAuthDetails(updateAppointmentUpdateBO.clientId)">
                            </ng-select>
                        </div>
                    </div>
                    <!-- Employee Name -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Employee Name <sup *ngIf="checkScheduleType=='parentgrid'"
                                    class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12">
                            <input *ngIf="checkScheduleType=='childgrid'" [(ngModel)]="employeeName"
                                class="form-control" disabled>
                            <ng-select *ngIf="checkScheduleType=='parentgrid'"
                                [(ngModel)]="updateAppointmentUpdateBO.employeeId"
                                [disabled]="updateAppointmentUpdateBO.clientId==null || updateAppointmentUpdateBO.clientId==undefined || updateAppointmentUpdateBO.clientId=='00000000-0000-0000-0000-000000000000'"
                                [searchable]="true" [clearable]="true" bindLabel="name" bindValue="id"
                                [items]="MappedEmployeeDropdown" (ngModelChange)="getClientServiceDropdown('clear')">
                            </ng-select>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Start Date -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Start Date <sup *ngIf="scheduleRadioType=='selectdaterange'"
                                    class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12 " *ngIf="((scheduleRadioType=='enterseries' && checkScheduleType=='parentgrid') ||checkScheduleType=='childgrid')
                        ">
                            <input type="text" [(ngModel)]="startDate" disabled class="form-control" />
                        </div>
                        <div class="col-lg-12 " *ngIf="scheduleRadioType=='selectdaterange'">

                            <my-date-picker placeholder="mm/dd/yyyy" [selDate]="startDate"
                                [options]="PastandFutureOption"
                                (inputFieldChanged)="Schedulenewdates($event,'inputchanged','ScheduleStart')"
                                (dateChanged)="Schedulenewdates($event,'datechanged','ScheduleStart')">
                            </my-date-picker>
                        </div>

                    </div>
                    <!-- End Date  -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">End Date <sup *ngIf="scheduleRadioType=='selectdaterange'"
                                    class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12 " *ngIf="((scheduleRadioType=='enterseries' && checkScheduleType=='parentgrid') ||checkScheduleType=='childgrid')
                        ">
                            <input type="text" [(ngModel)]="endDate" disabled class="form-control" />
                        </div>
                        <div class="col-lg-12 " *ngIf="scheduleRadioType=='selectdaterange'">
                            <my-date-picker placeholder="mm/dd/yyyy" [selDate]="endDate" [options]="PastandFutureOption"
                                (inputFieldChanged)="Schedulenewdates($event,'inputchanged','ScheduleEnd')"
                                (dateChanged)="Schedulenewdates($event,'datechanged','ScheduleEnd')">
                            </my-date-picker>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Start Time -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Start Time <sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-12 ">
                            <input type="time" [(ngModel)]="updateAppointmentUpdateBO.startTime" class="form-control" />
                        </div>
                    </div>
                    <!-- End Time -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">End Time <sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-12 ">
                            <input type="time" [(ngModel)]="updateAppointmentUpdateBO.endTime" class="form-control" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!-- Service Group -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Service Group <sup *ngIf="checkScheduleType=='parentgrid'"
                                    class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12">
                            <input [(ngModel)]="serviceGroupName" *ngIf="checkScheduleType=='childgrid'"
                                class="form-control" disabled>

                            <ng-select *ngIf="checkScheduleType=='parentgrid'"
                                [(ngModel)]="updateAppointmentUpdateBO.serviceGroupId"
                                [disabled]="updateAppointmentUpdateBO.employeeId==null || updateAppointmentUpdateBO.employeeId==undefined || updateAppointmentUpdateBO.employeeId=='00000000-0000-0000-0000-000000000000'"
                                [searchable]="true" [clearable]="false" bindLabel="serviceGroupName"
                                (ngModelChange)="getServiceName()" bindValue="serviceGroupId"
                                [items]="MappedServiceGroupDropdown">
                            </ng-select>
                        </div>
                    </div>
                    <!-- Custom Frequency -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Custom Frequency <sup
                                    *ngIf="scheduleRadioType=='selectdaterange'" class="super-script">*</sup> </label>
                        </div>

                        <div class="col-lg-12" *ngIf="((scheduleRadioType=='enterseries' && checkScheduleType=='parentgrid') ||checkScheduleType=='childgrid')
                        ">
                            <input [(ngModel)]="frequency" class="form-control" disabled>
                        </div>
                        <div class="col-lg-12 " *ngIf="scheduleRadioType=='selectdaterange'">
                            <ng-select [(ngModel)]="updateAppointmentUpdateBO.updateCustomFrequencyLid"
                                [searchable]="true" [clearable]="false" bindLabel="lovName" bindValue="id"
                                [items]="ListScheduleInputProperty.CustomFrequencyList"
                                (ngModelChange)="checkCustomFrequencyType(updateAppointmentUpdateBO.updateCustomFrequencyLid)">
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                    </div>
                    <!-- Custom Frequency -->
                    <div class="col-lg-6" *ngIf="showDays">
                        <ng-container *ngFor="let FD of updateAppointmentUpdateBO.appointmentDays ;">
                            <input type="checkbox" [(ngModel)]="FD.ischecked" [disabled]="checkScheduleType=='childgrid' ||
                            scheduleRadioType=='enterseries'">
                            <label class="ms-2 mt-2"
                                [style.font-weight]="FD.ischecked==true? '700' : '400'">{{FD.Key}}</label>&nbsp;
                        </ng-container>
                    </div>
                </div>
                <div class="row" *ngIf="checkScheduleType=='childgrid'">

                    <div class="col-lg-12 mt-1">
                        <label class="  " style="color:red"><i>Note:&nbsp;only start Time & End Time editable
                            </i></label>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-12 ">
                        <div class="control-section">
                            <ejs-grid #gridAuthDetails [dataSource]='AuthorizationDetails' [allowResizing]='true'
                                [allowSorting]='false' allowPaging='true' [allowFiltering]='false'
                                [pageSettings]='initialPage' [showColumnChooser]='true'>
                                <e-columns>
                                    <!-- Start Date -->
                                    <e-column field="startDate" headerText="Start Date" width=150 textAlign='center'
                                        [allowEditing]='false' type='date' [format]='formatOptions'>
                                    </e-column>
                                    <!-- End Date -->
                                    <e-column field='endDate' headerText='End Date' width=150 textAlign='left'
                                        [allowEditing]='false' type='date' [format]='formatOptions'>
                                    </e-column>
                                    <!-- Service -->
                                    <e-column field='serviceCode' headerText='Service' width=100 textAlign='center'
                                        [allowEditing]='false' type='string'>
                                    </e-column>
                                    <!-- Service Agreement# -->
                                    <!-- <e-column field='seAgreementNo' headerText='Service Agreement' width=100
                                        textAlign='center' [allowEditing]='false' type='string'>
                                    </e-column> -->
                                    <!-- Insurance Number#-->
                                    <e-column field='insuranceNumber' headerText='Insurance No' width=100
                                        textAlign='center' [allowEditing]='false' type='string'>
                                    </e-column>
                                    <!-- Total Amount -->
                                    <e-column field='totalAmt' headerText='Total Amount' width=100 textAlign='center'
                                        [allowEditing]='false' type='number'>
                                    </e-column>
                                    <!-- Payer Name	 -->
                                    <e-column field='payorName' headerText='Payer Name' width=100 textAlign='center'
                                        [allowEditing]='false' type='string'>
                                    </e-column>
                                    <!-- Total Hours  -->
                                    <e-column field='totalhours' headerText='Payer Name' width=100 textAlign='center'
                                        [allowEditing]='false' type='string'>
                                    </e-column>
                                    <!-- Remaining Amount -->
                                    <e-column field='remainingAmt' headerText='Remaining Amount' width=100
                                        textAlign='center' [allowEditing]='false' type='string'>
                                    </e-column>
                                    <!--Hours/day -->
                                    <!-- <e-column headerText="Hours/day" textAlign="center" [showInColumnChooser]='false'
                                        width=100>
                                        <ng-template #template let-data>
                                            <label> {{data.unithr }} hrs {{data.unitmin}} mins</label>
                                        </ng-template>
                                    </e-column> -->
                                    <!-- Company Name	 -->
                                    <e-column field='companyName' headerText='Company Name' width=100 textAlign='center'
                                        [allowEditing]='false' type='string'>
                                    </e-column>
                                    <!-- Remaining hours per day -->
                                    <!-- <e-column headerText="Remaining hours per day" field="remainunitperDay"
                                        textAlign="center" [showInColumnChooser]='false' width=150>
                                    </e-column> -->


                                </e-columns>
                            </ejs-grid>
                            <div *ngIf="AuthorizationDetails.length==0" class="text-center" style="color:red">
                                <p>No data available</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row ">
                    <div class="col-lg-12 ">
                        <button class="btn blue-btn btn-sm" (click)="UpdateScheduleAppointment()" [disabled]="IsButtonDisable || updateAppointmentUpdateBO.startTime==null || updateAppointmentUpdateBO.startTime==undefined ||
                        updateAppointmentUpdateBO.startTime=='' ||updateAppointmentUpdateBO.endTime==null || updateAppointmentUpdateBO.endTime==undefined ||
                        updateAppointmentUpdateBO.endTime=='' ||updateAppointmentUpdateBO.clientId==null || updateAppointmentUpdateBO.clientId==undefined || updateAppointmentUpdateBO.clientId=='00000000-0000-0000-0000-000000000000'
                        ||updateAppointmentUpdateBO.employeeId==null || updateAppointmentUpdateBO.employeeId==undefined || updateAppointmentUpdateBO.employeeId=='00000000-0000-0000-0000-000000000000'||
                     serviceGroupName==null ||serviceGroupName==undefined || serviceGroupName==''
                      ||startDate==null || startDate==undefined ||startDate==''  ||endDate==null || endDate==undefined ||
                        endDate=='' || frequency==null || frequency==undefined ||frequency==''||
                        updateAppointmentUpdateBO.updateCustomFrequencyLid==null ||
                        updateAppointmentUpdateBO.updateCustomFrequencyLid==undefined  ||
                        updateAppointmentUpdateBO.updateCustomFrequencyLid=='00000000-0000-0000-0000-000000000000'   ||
                        updateAppointmentUpdateBO.serviceGroupId ==null || updateAppointmentUpdateBO.serviceGroupId==undefined||
                        updateAppointmentUpdateBO.serviceGroupId=='00000000-0000-0000-0000-000000000000'    ">
                            Update & Close
                        </button>
                        <button class="btn blue-btn btn-sm ms-1" data-bs-dismiss="modal" data-bs-target="#modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>